var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopySuccess = function SvgCopySuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 51 51"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.667 4.332H24.855a7.687 7.687 0 0 0-7.688 7.667v1.708h8.98A10.834 10.834 0 0 1 36.958 24.52v8.979h1.708a7.687 7.687 0 0 0 7.667-7.688V12a7.667 7.667 0 0 0-7.667-7.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.146 16.832H12.334a7.687 7.687 0 0 0-7.667 7.688v13.812a7.667 7.667 0 0 0 7.667 7.667h13.812a7.69 7.69 0 0 0 7.688-7.667V24.52a7.69 7.69 0 0 0-7.688-7.688m1.063 11.5L19.5 35.77a1.583 1.583 0 0 1-2.208 0l-3.667-3.771a1.562 1.562 0 0 1 2.23-2.084l2.583 2.542 6.604-6.375a1.563 1.563 0 1 1 2.167 2.25",
    opacity: 0.3
  }))));
};
export default SvgCopySuccess;